import { isLeapJalaliYear } from "../_lib/jalali.js";

/**
 *
 * @param year {number}
 * @returns {boolean}
 */
export function isLeapYear(year) {
  return isLeapJalaliYear(year);
}
